import { css } from '@emotion/css';

export const saveButton = css`
  label: save;
  margin-left: -2px;
`;
